






























import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import ContactApi from '@/apis/ContactApi';
import ContactSupportRequestModel from '@/models/contact/ContactSupportRequestModel';

@Component({
        name: 'Contact',
    },
)
export default class Contact extends ViewBase {
    public givenName: string = '';
    public surname: string = '';
    public emailAddress: string = '';
    public message: string = '';

    public givenNameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A first name is required.';
        }

        return true;
    }

    public surnameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A last name is required.';
        }

        return true;
    }

    public emailRules(value: string ): any {
        if ( value.trim().length === 0)
        {
            return 'An email address is required.';
        }
        else if ( value.length < 5)
        {
            return 'Minimum email address length is 5 characters.';
        }

        return true;
    }

    public messageRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A message is required.';
        }

        return true;
    }

    public async sendClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new ContactSupportRequestModel();
                request.givenName = this.givenName;
                request.surname = this.surname;
                request.emailAddress = this.emailAddress;
                request.message = this.message;

                const api = new ContactApi();
                const response = await api.contactSupportAsync(request);

                this.givenName = '';
                this.surname = '';
                this.emailAddress = '';
                this.message = '';
                this.resetFormValidation();
                this.$store.commit('mutateSnackbarText', 'Thank you for contacting CashTamer.com.');
                this.$store.commit('mutateShowSnackbar', true);
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.contactForm;

        return form.validate();
    }

    private resetFormValidation() {
        const form: any = this.$refs.contactForm;

        form.resetValidation();
    }

}
